import React, { useEffect, useRef } from "react";
import StyledHeader from "./styles";
import NavbarBrand from "react-bootstrap/NavbarBrand";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";
import { isMobileOrTablet } from "../../utilities";

export default function Header({ logo }) {
  const navbarRef = useRef();
  const prevScrollRef = useRef(window.scrollY);

  useEffect(() => {
    function headerScroll() {
      const currentScrollPos = window.scrollY;
      const navbar = navbarRef.current;
      const isSmallDevice = isMobileOrTablet();

      if (currentScrollPos <= 32) {
        navbar.classList.remove("active");
      } else {
        if (prevScrollRef.current > currentScrollPos) {
          // Perform your desired actions for scrolling up here
          navbar.classList.remove("nav-transition");
          navbar.classList.add("active");
        } else if (prevScrollRef.current < currentScrollPos) {
          // Perform your desired actions for scrolling down here
          if (isSmallDevice) {
            navbar.classList.remove("active");
            navbar.classList.add("nav-transition");
          } else {
            navbar.classList.remove("nav-transition");
            navbar.classList.add("active");
          }
        }
      }
      prevScrollRef.current = currentScrollPos;
    }

    window.addEventListener("scroll", headerScroll);

    return () => window.removeEventListener("scroll", headerScroll);
  }, []);

  return (
    <StyledHeader
      logo={logo}
      id="navbar"
      collapseOnSelect
      bg="light"
      expand="lg"
      fixed="top"
      ref={navbarRef}
    >
      <div className="container-fluid navbar-container">
        <div className="logo-container">
          <NavbarBrand
            as="a"
            target="_blank"
            rel="noreferrer"
            href="https://www.swmc.com/"
          />
        </div>
        <div className="userway-container">
          <UserWayAccessibilityMenu />
        </div>
      </div>
    </StyledHeader>
  );
}